import frUtils from '../util/frUtils';
import frSticky from '../components/sticky-sidebar';
import horizontalCard from '../components/horizontal-card';

(function ($) {
    $.fn.sidebarFilters = function () {

        let ajaxConfig;
        let $filterContainer;
        let $ajaxContainer;
        let $form;
        let $headerForm;
        let $filters;
        let $clearBtn;
        let $sortBySelect;
        let $sortByToggle;
        let $searchInput;
        let $searchBtn;
        const resultContainer = $('#result-content');
        let pagesContainer;
        let pagination;
        let ajaxRunning = false;
        let noMoreResults = false;
        let filters = [
            'search',
            'resource-content-type_tax',
            'program_tax',
            'workstream_tax',
            'partner_tax',
            'sort_by',
            'event-type_tax',
            'access-type_tax'];

        let taxonomyFilters = [
            'resource-content-type_tax',
            'program_tax',
            'workstream_tax',
            'partner_tax',
            'event-type_tax',
            'access-type_tax'];

        let canChangeUrl = true;

        this.each((index, element) => {

            $filterContainer = $(element);
            $ajaxContainer = $filterContainer.find('.ajax-container').first();
            $form = $filterContainer.find('.filters-form').first();
            $headerForm = $filterContainer.find('.header-form').first();
            $filters = $filterContainer.find('input[type="checkbox"]');
            $clearBtn = $filterContainer.find('.clear-filters-btn');
            $sortBySelect = $headerForm.find('.custom-select');
            $sortByToggle = $sortBySelect.find('#sort_input-dropdown');
            $searchInput = $headerForm.find('#search_input');
            $searchBtn = $headerForm.find('#search_input_btn');
            pagination = $filterContainer.find('.pagination-loading');

            ajaxConfig = JSON.parse(($filterContainer.attr('ajax-config') ? $filterContainer.attr('ajax-config') : '{}'));

            // On filters change
            $filters.on('change', (e) => {
                updateFilters(e.target);
            });

            // On click clear button
            $clearBtn.on('click', () => {
                clearFilters();
            });

            // On sort by change
            $sortBySelect.on('fr:update-custom-select', () => {
                setSorting();
            });

            // On click search button
            $searchBtn.on('click', () => {
                updateFilters();
            });

            // Function for initialize
            const init = () => {
                frUtils.init();
                setFiltersOnLoading();
            }

            // Function for update filters
            const updateFilters = ($clickedFilter) => {
                let needReset = true;
                let childFilters;
                ajaxConfig.include_featured = false;
                ajaxConfig.page = 0;

                // Select all childs
                if ($clickedFilter) {
                    childFilters = $($clickedFilter).closest('.accordion-item').find('input[type="checkbox"]');

                    childFilters.each((i, childFilter) => {
                        document.getElementById($(childFilter).attr('id')).checked = document.getElementById($($clickedFilter).attr('id')).checked;
                    });
                }

                // Clear all array
                $filters.each((index, $filter) => {
                    ajaxConfig[$($filter).attr('data-taxonomy')] = [];
                });

                // Add params
                $filters.each((index, $filter) => {
                    if (document.getElementById($($filter).attr('id')).checked) {
                        ajaxConfig[$($filter).attr('data-taxonomy')].push($($filter).val());
                        needReset = false;
                    }
                });

                // Add search text
                if ($searchInput[0]) {
                    ajaxConfig[$($searchInput).attr('name')] = $($searchInput).val();
                    if ($($searchInput).val() !== '') needReset = false;
                }

                // If need reset
                if (needReset) resetFilters();

                setResultByFilters();
            }

            // Function for clear filters
            const clearFilters = () => {
                $form[0].reset();

                // If search text
                if ($searchInput[0]) {
                    $($searchInput).val('');
                }

                updateFilters();
            }

            // Function for reset filters
            const resetFilters = () => {
                // ajaxConfig = JSON.parse(($filterContainer.attr('ajax-config')?$filterContainer.attr('ajax-config'):'{}'));
                noMoreResults = false;
                ajaxConfig.include_featured = true;
            }

            // Function for set order by
            const setSorting = () => {
                ajaxConfig.page = 0;
                ajaxConfig['sort_by'] = $($sortByToggle).val();
                setResultByFilters();
            }

            // Function for set pagination
            const setPagination = (max_num_pages) => {
                noMoreResults = (ajaxConfig.page >= (max_num_pages - 1));

                // If noMoreResults
                if (noMoreResults) {
                    pagination.removeClass('loading');
                }
                else {
                    pagination.addClass('loading');
                }
            }

            // On window scroll to bottom then loadMore content
            $(window).on('scroll', function () {
                if (noMoreResults) return;

                var windowBottom = window.scrollY + window.innerHeight;
                var wrapperBottom = resultContainer.height() + resultContainer.offset().top;

                if (windowBottom >= wrapperBottom) {
                    loadNextPage();
                }
            });

            $('.mobile-filter #filter_btn').on('click', function(){
                if($('#filter_btn').hasClass('open'))
                {
                    $(this).removeClass('open');
                    $('.filters-input-container.main-left-content').addClass('remove-filter').removeClass('open-filter');

                }
                else{
                    $(this).addClass('open');
                    $('.filters-input-container.main-left-content').addClass('open-filter').removeClass('remove-filter');
                }
                
            });
            
            
            // On window url change
            window.onpopstate = function (event) {
                if (event.state) {
                    setFiltersOnLoading();
                } else {
                    // history changed because of a page load
                }
            }


            // Function to change url
            const changeWindowUrl = (ajaxConfig) => {
                // Don't do anything
                if (!canChangeUrl) return;

                var urlParams = {};
                filters.forEach((filterName) => {
                    if (ajaxConfig[filterName] && ajaxConfig[filterName].length > 0) {
                        urlParams[filterName] = ajaxConfig[filterName];
                    }
                });

                frUtils.setUrlParams(urlParams);
            }

            // Function to set filters value on loading
            const setFiltersOnLoading = () => {

                let urlParams = frUtils.getUrlParams();

                // Reset all checkboxes
                $form[0].reset();

                // Set all filters
                filters.forEach((filterName) => {
                    // Return if not having urlParam for current filter
                    if (!urlParams.hasOwnProperty(filterName)) return;

                    // Check if current filterName is search
                    if (filterName === 'search') {
                        $($searchInput).val(urlParams[filterName]);
                    }

                    // Check if current filterName is taxonomy filter
                    if (taxonomyFilters.includes(filterName)) {
                        let presentValues = urlParams[filterName].split(',');
                        presentValues.forEach((value) => {
                            let currentInput = document.getElementById(filterName + '_' + value);
                            if(currentInput){
                                currentInput.checked = true;
                            }
                        });
                    }
                });

                ajaxConfig.page = 0;
                canChangeUrl = false;
                updateFilters();
            }

            // Function for get html data by selected filters
            const setResultByFilters = () => {
                $ajaxContainer.addClass('loading');

                // Get data using ajax
                $.frAjax({
                    action: ajaxConfig.action,
                    data: ajaxConfig,
                    onComplete: () => {
                        $ajaxContainer.removeClass('loading');
                        changeWindowUrl(ajaxConfig);
                        canChangeUrl = true;
                        frSticky.update();
                    },
                }).then(data => {
                    resultContainer.html(data.html);
                    if(!$.frScrollTo($ajaxContainer[0], -100)){
                        $.frScrollTo(null, -10);
                    }

                    horizontalCard.init();
                    setPagination(data.max_num_pages);
                }).catch(err => {
                    console.log(`Error ${err}`);
                });
            }

            // Function for get html data for next page
            const loadNextPage = () => {
                if (ajaxRunning) return;
                pagesContainer = $('#pages-container');
                pagesContainer = pagesContainer[0] ? pagesContainer : resultContainer;

                //Start
                ajaxRunning = true;

                ajaxConfig.page += 1;
                ajaxConfig.include_featured = false;

                // Get data using ajax
                $.frAjax({
                    action: ajaxConfig.action,
                    data: ajaxConfig,
                    onComplete: () => {
                        ajaxRunning = false;
                        frSticky.update();
                    },
                }).then(data => {
                    pagesContainer.append(data.html);
                    horizontalCard.init();
                    setPagination(data.max_num_pages);
                }).catch(err => {
                    console.log(`Error ${err}`);
                });
            }


            init();
        });

        return this;
    }

    $(() => {
        $('.filters-container').sidebarFilters();
    })

})($);




// WEBPACK FOOTER //
// ./scripts/components/sidebar-filters.js